import React, { useEffect, useState } from "react";
import filterIcon from "../../Icons/filterIcon.png";
import axios from "axios";
import Loader from "../../components/Loader/loader";
import ExcelExport from "../ExcelExport/ExcelExportOperation";

import "../../components/LeadDataReport/LeadDataReport.css";

import "../../components/ConvertedLeadData/ConvertedLeadData.css";
import { DateRangePicker } from "react-date-range";
import CryptoJS from 'crypto-js';
import "react-toastify/dist/ReactToastify.css";

const ConvertedSalesOrder = () => {
  const [convertedleadResponse, setConvertedLeadResponse] = useState([]);
  const [fieldopsresponse, setFieldOpsResponse] = useState([]);
  const itemsPerPage = 50;
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [showFilterDiv, setShowFilterDiv] = useState(false);
  const toggleFilterDiv = () => {
    setShowFilterDiv(!showFilterDiv); // This will toggle the visibility of the div
  };
  const [selectedAttributeDate, setSelectedAttributeDate] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [dateRange, setDateRange] = useState("Custom Dates");
  const [serviceTypeData, setServiceTypeData] = useState("");
  const [statusData, setStatusData] = useState("");
  const [regionData, setRegionData] = useState("");
  const [City, setCity] = useState("");
  const [originCityResponse, setOriginCityResponse] = useState([]);
  const [destinationCityResponse, setDestinationCityResponse] = useState([]);
  const [petBreedResponse, setPetBreedResponse] = useState([]);
  const [petTypeResponse, setPetTypeResponse] = useState([]);
  const [leadSourceData, setLeadSourceData] = useState("");
  const [leadSourceResponse, setLeadSourceResponse] = useState([]);
  const [assignedTo, setAssignedTo] = useState("");
  const [assignToResponse, setAssignToResponse] = useState([]);
  const [fieldOps, setFieldOps] = useState("");
  const [fieldOpsFilterResponse, setFieldOpsFilterResponse] = useState([]);
  const [coordinator, setCoordinator] = useState([]);
  const [coordinatorName, setCoordinatorName] = useState([]);
  const [coordinatorFilterResponse, setcoordinatorFilterResponse] = useState(
    []
  );
  const [modeData, setModeData] = useState("");
  const [paymentModeData, setPaymentModeData] = useState("");
  const [petCount, setPetCount] = useState("");
  const [originCountryResponse, setOriginCountryResponse] = useState([]);
  const [originStateResponse, setOriginStateResponse] = useState([]);
  const [destinationStateResponse, setDestinationStateResponse] = useState([]);
  const [currency, setCurrency] = useState("");
  const [inputDataValue, setInputDataValue] = useState("");
  const [fileSubmit, setFileSubmit] = useState([]);

  const baseAPI = process.env.REACT_APP_API_URL;
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const storedToken = JSON.parse(localStorage.getItem("token"));
      if (baseAPI.includes("aeapi")) {
        setCurrency("INR");
      } else {
        setCurrency("AED");
      }
      if (storedToken) {
        try {
          const [leadResponse, fieldOpsResponse, coordinator] =
            await Promise.all([
              axios.get(
                `${baseAPI}userget/GetConvertedLeadDataReport?dateAttribute=&startDate=&enddate=&status=&serviceType=&region_name=&originCountry=&originState=&originCity=&destinationCountry=&destinationState=&destinationCity=&petType=&petBreed=&leadSource=&leadowner=&operationCor=&fieldCor=&cageSize=&overseasVendor=&mode=&paymentMode=&petCount=&searchParam=&File_Submit_in_Accounts=`,
                {
                  headers: {
                    Authorization: `Bearer ${storedToken}`,
                  },
                }
              ),
              axios.get(`${baseAPI}userget/GetFieldOpsPersons`, {
                headers: {
                  Authorization: `Bearer ${storedToken}`,
                },
              }),
              axios.get(`${baseAPI}userget/GetCoordinatorPersons`, {
                headers: {
                  Authorization: `Bearer ${storedToken}`,
                },
              }),
            ]);
          setConvertedLeadResponse(leadResponse.data.data);
          setFieldOpsResponse(
            fieldOpsResponse.data.data.map((name) => ({ name }))
          );
          setCoordinator(coordinator.data.data.map((Name) => ({ Name })));
        } catch (error) {
          console.error("Error fetching data:", error);
        } finally {
          setLoading(false);
        }
      }
    };
    fetchData();
  }, []);

  const handleChangeDestination = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  let mystyle = {
    "::-webkit-scrollbar": {
      display: "none",
    },
  };
  const handleSubmit = (e) => {
    e.preventDefault();
  };
  const handleChangeAttribute = (event) => {
    setSelectedAttributeDate(event.target.value);
  };
  const togglePicker = () => {
    setIsOpen(!isOpen);
  };
  const [selectionRange, setSelectionRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: "selection",
  });
  const handleSelect = (ranges) => {
    setSelectionRange(ranges.selection);
  };
  function formatDate(dateString) {
    const date = new Date(dateString);
    const options = { day: "2-digit", month: "short", year: "numeric" };
    return date.toLocaleDateString("en-US", options);
  }
  const handleApplyFilter = () => {
    setDateRange(
      formatDate(selectionRange.startDate) +
      " - " +
      formatDate(selectionRange.endDate)
    );
    setIsOpen(false);
    // You can perform additional actions here based on the selected attribute and date range
  };
  const handleClearFilter = () => {
    setDateRange("");
    setSelectedAttributeDate("");
    setIsOpen(false);
    setSelectionRange({
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    });
  };
  const renderDateRangePicker = () => {
    return (
      isOpen && (
        <div
          style={{
            position: "absolute",
            zIndex: 999,
            border: "solid 1px black",
            marginLeft: "1rem",
            width: "35pc",
            background: "white",
          }}
        >
          <DateRangePicker ranges={[selectionRange]} onChange={handleSelect} />
          <button
            onClick={handleApplyFilter}
            style={{
              marginBottom: "1rem",
              width: "8rem",
              height: "2.5rem",
              borderRadius: "0.5rem",
              fontSize: "13px",
              position: "relative",
              top: "1px",
              left: "19pc",
              backgroundColor: "#5B489D",
              color: "White",
              border: "none",
            }}
          >
            Apply Filter
          </button>
          <button
            onClick={handleClearFilter}
            style={{
              marginBottom: "1rem",
              width: "7.5rem",
              height: "2.5rem",
              borderRadius: "0.5rem",
              fontSize: "13px",
              position: "relative",
              top: "1px",
              left: "19pc",
              color: "red",
              backgroundColor: "white",
              border: "none",
              fontWeight: "bold",
            }}
          >
            Clear Filter
          </button>
        </div>
      )
    );
  };
  const handleServiceType = (event) => {
    setServiceTypeData(event.target.value);
  };
  const handleStatus = (event) => {
    setStatusData(event.target.value);
  };
  const handleSelectRegion = (event) => {
    setRegionData(event.target.value);
  };
  function getCity(state_id, type) {
    if (state_id !== null && state_id !== "0") {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      axios
        .get(`${baseAPI}adminget/GETCity?cityID=0&stateID=` + state_id, {
          headers: {
            Authorization: "Bearer " + storedToken,
          },
        })
        .then((response) => {
          if (type === 1) {
            setOriginCityResponse(response.data.data);
          } else if (type === 2) {
            setDestinationCityResponse(response.data.data);
          }
        });
    }
  }
  const resetForm = () => {
    setSelectedAttributeDate("");
    setDateRange("");
    setStatusData("");
    setLeadSourceData("");
    setPaymentModeData("");
    setServiceTypeData("");
    setRegionData("");
    setCity("");
    setModeData("");
    setAssignedTo("");
    setFieldOps("");
    setPetCount("");
    setCoordinatorName("");
    setInputDataValue("");
    setFileSubmit("");
    setFormData({
      city: "",
      originCountry: "",
      originState: "",
      country: "",
      state: "",
      petType: "",
      petBreed: "",
    });
    setSelectionRange({
      startDate: "",
      endDate: "",
      key: "selection",
    });
  };
  const [formData, setFormData] = useState({
    originCountry: "",
    originState: "",
    city: "",
    country: "",
    state: "",
    originCity: "",
    petType: "",
    petBreed: "",
  });
  const handleSelectChangePetType = (event) => {
    formData.petType = event.target.value;
    getPetBreed(event.target.value);
  };
  function getPetType() {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    if (storedToken) {
      axios
        .get(`${baseAPI}adminget/GEPetType?PetType=0`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          setPetTypeResponse(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }
  function getPetBreed(pet_type) {
    if (pet_type === null || pet_type === "") {
      pet_type = 0;
    }
    const storedToken = JSON.parse(localStorage.getItem("token"));
    axios
      .get(
        `${baseAPI}adminget/GEPetBreedType?PetBreedID=0&PetType=` + pet_type,
        {
          headers: {
            Authorization: "Bearer " + storedToken,
          },
        }
      )
      .then((response) => {
        setPetBreedResponse(response.data.data);
      });
  }
  const handleChangePetBreed = (event) => {
    const selectedPetBreed = event.target.value;
    setFormData({
      ...formData,
      petBreed: selectedPetBreed, // Update the petBreed value
    });
  };
  const handleSelectChange = (event) => {
    setLeadSourceData(event.target.value);
  };
  const handleSelectMode = (event) => {
    setModeData(event.target.value);
  };
  const handleSelectPaymentMode = (event) => {
    setPaymentModeData(event.target.value);
  };
  const handleSelectPetCount = (event) => {
    setPetCount(event.target.value);
  };
  const handleSelectCoordinator = (event) => {
    setCoordinatorName(event.target.value);
  };

  const handleSearchParamChange = (event) => {
    setInputDataValue(event.target.value);
  };

  const handleSelectFileSubmit = (event) => {
    setFileSubmit(event.target.value);
  };

  const leadSource = async () => {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    if (storedToken) {
      axios
        .get(`${baseAPI}adminget/GETLeadSource?LeadSourceID=0`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          setLeadSourceResponse(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching Lead Source detail:", error);
        });
    }
  };
  function getEmployeeByDepartment() {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    axios
      .get(`${baseAPI}adminget/GETEmployeeByDepartment?department_id=3`, {
        headers: {
          Authorization: `Bearer ${storedToken}`,
        },
      })
      .then((response) => {
        setAssignToResponse(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching user detail:", error);
      });
  }
  function getFieldOpsCordinator() {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    axios
      .get(`${baseAPI}userget/GetFieldOpsPersons`, {
        headers: {
          Authorization: `Bearer ${storedToken}`,
        },
      })
      .then((response) => {
        // setFieldOpsFilterResponse(response.data.data);
        setFieldOpsFilterResponse(response.data.data.map((name) => ({ name })));
      })
      .catch((error) => {
        console.error("Error fetching user detail:", error);
      });
  }
  function getCoordinatorNames() {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    axios
      .get(`${baseAPI}userget/GetCoordinatorPersons`, {
        headers: {
          Authorization: `Bearer ${storedToken}`,
        },
      })
      .then((response) => {
        setcoordinatorFilterResponse(
          response.data.data.map((Name) => ({ Name }))
        );
      })
      .catch((error) => {
        console.error("Error fetching user detail:", error);
      });
  }
  function getLeadDataButton() {
    setLoading(true);
    const storedToken = JSON.parse(localStorage.getItem("token"));
    let startdate = formatDate(selectionRange.startDate);
    let enddate = formatDate(selectionRange.endDate);
    if (dateRange === "Custom Dates") {
      startdate = "";
      enddate = "";
    }
    if (storedToken) {
      axios
        .get(
          `${baseAPI}userget/GetConvertedLeadDataReport?dateAttribute=${selectedAttributeDate}&startDate=${startdate}&enddate=${enddate}&status=${statusData}&serviceType=${serviceTypeData}&region_name=${regionData}&originCountry=${formData.originCountry}&originState=${formData.originState}&originCity=${City}&destinationCountry=${formData.country}&destinationState=${formData.state}&destinationCity=${formData.city}&petType=${formData.petType}&petBreed=${formData.petBreed}&leadSource=${leadSourceData}&leadowner=${assignedTo}&operationCor=${coordinatorName}&fieldCor=${fieldOps}&cageSize=&overseasVendor=&mode=${modeData}&paymentMode=${paymentModeData}&petCount=${petCount}&searchParam=${inputDataValue}&File_Submit_in_Accounts=${fileSubmit}`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          if (response) {
            setConvertedLeadResponse(response.data.data);

          }
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        })
        .finally(() => {
          setLoading(false); // Set loading to false when data is fetched
        });
    }
  }
  const getCountry = async () => {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    if (storedToken) {
      axios
        .get(`${baseAPI}adminget/GETCountry?countryID=0`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          setOriginCountryResponse(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching Country detail:", error);
        });
    }
  };
  function getState(country_id, type) {
    if (country_id !== null && country_id !== "0") {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      axios
        .get(`${baseAPI}adminget/GETState?stateID=0&countryID=` + country_id, {
          headers: {
            Authorization: "Bearer " + storedToken,
          },
        })
        .then((response) => {
          if (type === 1) {
            setOriginStateResponse(response.data.data);

          } else if (type === 2) {
            setDestinationStateResponse(response.data.data);

          }
        });
    }
  }
  const handleSelectChangeOriginCountry = (event) => {
    formData.originCountry = event.target.value;
    getState(event.target.value, 1);
  };
  const handleSelectChangeOriginState = (event) => {
    formData.originState = event.target.value;
    getCity(event.target.value, 1);
  };
  const handleSelectChangeDestinationCountry = (event) => {
    formData.country = event.target.value;
    getState(event.target.value, 2);
  };
  const handleSelectChangeDestinationState = (event) => {
    formData.state = event.target.value;
    getCity(event.target.value, 2);
  };

  function nextPage1(Relocation_ID) {

    const key = 'dbbworldwidepvtltd';
    const encryptedRelocationID = encryptRelocationID(Relocation_ID, key);

    const url = `/viewleaddetail?Relocation_ID=${encryptedRelocationID}`;
    window.open(url, '_blank');
  }

  function encryptRelocationID(Relocation_ID, key) {
    const ciphertext = CryptoJS.AES.encrypt(Relocation_ID.toString(), key).toString();
    return encodeURIComponent(ciphertext);
  }





  return (
    <>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <button className="filterButton" onClick={toggleFilterDiv}>
          <img src={filterIcon} /> FILTER
        </button>
        <div style={{ display: "flex" }}>
          <p
            className="icon"
            style={{
              borderColor: "#5B489D",
              border: "2px solid #5B489D",
              textAlign: "center",
              padding: "7px",
              fontSize: "18px",
              fontWeight: "bold",
              height: "3rem",
              borderRadius: "0.5rem",
              color: "#6A6A6A",
              backgroundColor: "white",
              marginRight: "13px",
              width: "9rem",
            }}
          >
            {" "}
            {convertedleadResponse.length === 0 ? (
              <span>0 Records</span>
            ) : (
              <span>{convertedleadResponse.length} Records</span>
            )}
          </p>

          <ExcelExport convertedleadResponse={convertedleadResponse} />
        </div>
      </div>
      {showFilterDiv && (
        /*--------------------------------------filters---------------------------------------*/
        <form onSubmit={handleSubmit} className="formContainer">
          <div
            className="container wholeDivContainer"
            style={{ padding: "0px" }}
          >
            <div className="row">
              <div className="col fixArrow">
                <select
                  value={selectedAttributeDate}
                  onChange={handleChangeAttribute}
                  className="form-control optionSize "
                >
                  <option value="">Date Attribute</option>
                  <option value="1">Last Modified Date</option>
                  <option value="2">Last Entry Date</option>
                  <option value="3">Booking Date</option>
                  <option value="4">Execution Date</option>
                  <option value="5">AQCS NOC Date</option>
                  <option value="6">Pet DOB</option>
                </select>
                <span
                  className="arrow"
                  style={{
                    position: "relative",
                    marginLeft: "-32px",
                    marginTop: "14px",
                    color: "#BFBFBF",
                  }}
                >
                  &#9660;
                </span>
              </div>
              <div className="col fixArrow">
                {/* <div style={{ paddingRight: "6px" }}> */}
                <button
                  className="form-control optionSize dateRangeButton"
                  style={{
                    // marginBottom: "1rem",
                    height: "2.5rem",
                    borderRadius: "0.4rem",
                    fontSize: "14px",
                    textAlign: "left",
                  }}
                  onClick={togglePicker}
                >
                  {dateRange || "Custom Dates"}
                </button>
                <span
                  className="arrow"
                  style={{
                    position: "relative",
                    marginLeft: "-32px",
                    marginTop: "14px",
                    color: "#BFBFBF",
                  }}
                >
                  &#9660;
                </span>
                {renderDateRangePicker()}
                {/* </div> */}
              </div>
              <div className="col fixArrow">
                <select
                  id="statusData"
                  name="statusData"
                  value={statusData}
                  onChange={handleStatus}
                  className="form-control optionSize"
                  placeholder="status"
                >
                  <option value="">Status</option>
                  <option value="0">Untouched</option>
                  <option value="1">Open</option>
                  <option value="2">Executed</option>
                  <option value="3">Cancelled</option>
                  <option value="4">Abandoned</option>
                </select>
                <span
                  className="arrow"
                  style={{
                    position: "relative",
                    marginLeft: "-32px",
                    marginTop: "14px",
                    color: "#BFBFBF",
                  }}
                >
                  &#9660;
                </span>
              </div>
              <div className="col fixArrow">
                <select
                  id="serviceType"
                  name="serviceType"
                  value={serviceTypeData}
                  onChange={handleServiceType}
                  className="form-control optionSize"
                  placeholder="City or Region"
                >
                  <option value=""> Service Type</option>
                  <option value="1">International</option>
                  <option value="2">Domestic</option>
                </select>
                <span
                  className="arrow"
                  style={{
                    position: "relative",
                    marginLeft: "-32px",
                    marginTop: "14px",
                    color: "#BFBFBF",
                  }}
                >
                  &#9660;
                </span>
              </div>
            </div>
            <div className="row">
              <div className="col fixArrow">
                <select
                  id="region"
                  name="region"
                  value={regionData}
                  onChange={handleSelectRegion}
                  className="form-control optionSize"
                  placeholder="Select Region"
                >
                  <option value=""> Region</option>
                  <option value="1">North</option>
                  <option value="2">East</option>
                  <option value="3">West</option>
                  <option value="4">South</option>
                </select>
                <span
                  className="arrow"
                  style={{
                    position: "relative",
                    marginLeft: "-32px",
                    marginTop: "14px",
                    color: "#BFBFBF",
                  }}
                >
                  &#9660;
                </span>
              </div>
              <div className="col fixArrow">
                <select
                  id="originCountrySelect"
                  name="originCountrySelect"
                  onChange={handleSelectChangeOriginCountry}
                  value={formData.originCountry}
                  className="form-control optionSize"
                  onClick={getCountry}
                >
                  <option value=""> Origin Country</option>
                  {originCountryResponse.map((country) => (
                    <option key={country} value={country.id}>
                      {country.name}
                    </option>
                  ))}
                </select>
                <span
                  className="arrow"
                  style={{
                    position: "relative",
                    marginLeft: "-32px",
                    marginTop: "14px",
                    color: "#BFBFBF",
                  }}
                >
                  &#9660;
                </span>
              </div>
              <div className="col fixArrow">
                <select
                  id="originState"
                  name="originState"
                  value={formData.originState}
                  onChange={handleSelectChangeOriginState}
                  className="form-control optionSize"
                  placeholder="City or Region"
                >
                  <option value=""> Origin State</option>
                  {originStateResponse.map((item) => (
                    <option value={item.state_id}>{item.stateName}</option>
                  ))}
                </select>
                <span
                  className="arrow"
                  style={{
                    position: "relative",
                    marginLeft: "-32px",
                    marginTop: "14px",
                    color: "#BFBFBF",
                  }}
                >
                  &#9660;
                </span>
              </div>
              <div className="col fixArrow">
                <select
                  id="city"
                  name="city"
                  value={City}
                  onChange={(e) => setCity(e.target.value)}
                  className="form-control optionSize"
                  placeholder="City or Region"
                >
                  <option value=""> Origin City</option>
                  {originCityResponse.map((item) => (
                    <option value={item.id}>{item.name}</option>
                  ))}
                </select>
                <span
                  className="arrow"
                  style={{
                    position: "relative",
                    marginLeft: "-32px",
                    marginTop: "14px",
                    color: "#BFBFBF",
                  }}
                >
                  &#9660;
                </span>
              </div>
            </div>
            <div className="row">
              <div className="col fixArrow">
                <select
                  id="leadSource"
                  name="leadSource"
                  value={leadSourceData}
                  onChange={handleSelectChange}
                  className="form-control optionSize"
                  placeholder="City or Region"
                  onClick={leadSource}
                >
                  <option value=""> Lead Source</option>
                  {leadSourceResponse.map((leadsource) => (
                    <option
                      key={leadsource.leadsourceid}
                      value={leadsource.leadsourceid}
                    >
                      {leadsource.LeadSource}
                    </option>
                  ))}
                </select>
                <span
                  className="arrow"
                  style={{
                    position: "relative",
                    marginLeft: "-32px",
                    marginTop: "14px",
                    color: "#BFBFBF",
                  }}
                >
                  &#9660;
                </span>
              </div>
              <div className="col fixArrow">
                <select
                  id="destinationCountry"
                  name="destinationCountry"
                  value={formData.country}
                  onChange={handleSelectChangeDestinationCountry}
                  className="form-control optionSize"
                  placeholder="City or Region"
                  onClick={getCountry}
                >
                  <option value=""> Destination Country</option>
                  {originCountryResponse.map((country) => (
                    <option key={country} value={country.id}>
                      {country.name}
                    </option>
                  ))}
                </select>
                <span
                  className="arrow"
                  style={{
                    position: "relative",
                    marginLeft: "-32px",
                    marginTop: "14px",
                    color: "#BFBFBF",
                  }}
                >
                  &#9660;
                </span>
              </div>
              <div className="col fixArrow">
                <select
                  id="state"
                  name="state"
                  value={formData.state}
                  onChange={handleSelectChangeDestinationState}
                  className="form-control optionSize"
                  placeholder="City or Region"
                >
                  <option value=""> Destination State</option>
                  {destinationStateResponse.map((item) => (
                    <option value={item.state_id}>{item.stateName}</option>
                  ))}
                </select>
                <span
                  className="arrow"
                  style={{
                    position: "relative",
                    marginLeft: "-32px",
                    marginTop: "14px",
                    color: "#BFBFBF",
                  }}
                >
                  &#9660;
                </span>
              </div>
              <div className="col fixArrow">
                <select
                  id="city"
                  name="city"
                  value={formData.city}
                  onChange={handleChangeDestination}
                  className="form-control optionSize"
                  placeholder="City or Region"
                >
                  <option value=""> Destination City</option>
                  {destinationCityResponse !== null &&
                    destinationCityResponse !== undefined ? (
                    destinationCityResponse.map((item) => (
                      <option value={item.id}>{item.name}</option>
                    ))
                  ) : (
                    <p>empty</p>
                  )}
                </select>
                <span
                  className="arrow"
                  style={{
                    position: "relative",
                    marginLeft: "-32px",
                    marginTop: "14px",
                    color: "#BFBFBF",
                  }}
                >
                  &#9660;
                </span>
              </div>
            </div>
            <div className="row">
              <div className="col fixArrow">
                <select
                  id="petTypeSelect"
                  name="petType"
                  type="text"
                  value={formData.petType}
                  onChange={handleSelectChangePetType}
                  className="form-control optionSize"
                  onClick={getPetType}
                >
                  <option value="0"> Pet Type</option>
                  {petTypeResponse.map((item) => (
                    <option value={item.id}>{item.petType}</option>
                  ))}
                </select>
                <span
                  className="arrow"
                  style={{
                    position: "relative",
                    marginLeft: "-32px",
                    marginTop: "14px",
                    color: "#BFBFBF",
                  }}
                >
                  &#9660;
                </span>
              </div>
              <div className="col fixArrow">
                <select
                  id="petBreedSelect"
                  name="PetBreedType"
                  value={formData.petBreed}
                  onChange={handleChangePetBreed}
                  className="form-control optionSize"
                  placeholder="Pet Breed"
                >
                  <option value=""> Pet Breed</option>
                  {petBreedResponse.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.PetBreedType}
                    </option>
                  ))}
                </select>
                <span
                  className="arrow"
                  style={{
                    position: "relative",
                    marginLeft: "-32px",
                    marginTop: "14px",
                    color: "#BFBFBF",
                  }}
                >
                  &#9660;
                </span>
              </div>
              <div className="col fixArrow">
                <>
                  <select
                    id="assignto"
                    className="form-control optionSize"
                    name="assignto"
                    value={assignedTo}
                    onChange={(e) => setAssignedTo(e.target.value)}
                    onClick={getEmployeeByDepartment}
                  >
                    <option value="0">Lead owner</option>
                    {assignToResponse.map((item) => (
                      <option value={item.customer_id}>{item.name}</option>
                    ))}
                  </select>
                  <span
                    className="arrow"
                    style={{
                      position: "relative",
                      marginLeft: "-32px",
                      marginTop: "14px",
                      color: "#BFBFBF",
                    }}
                  >
                    &#9660;
                  </span>
                </>
              </div>
              <div className="col fixArrow">
                <select
                  id="fieldOps"
                  className="form-control optionSize"
                  name="fieldOps"
                  value={fieldOps}
                  onChange={(e) => setFieldOps(e.target.value)}
                  onClick={getFieldOpsCordinator}
                >
                  <option value="">Field Ops Coordinator</option>
                  {fieldOpsFilterResponse.map((item) => (
                    <option value={item.customer_id}>{item.name}</option>
                  ))}
                </select>
                <span
                  className="arrow"
                  style={{
                    position: "relative",
                    marginLeft: "-32px",
                    marginTop: "14px",
                    color: "#BFBFBF",
                  }}
                >
                  &#9660;
                </span>
              </div>
            </div>
            <div className="row">
              <div className="col fixArrow">
                <select
                  id="region"
                  name="region"
                  value={modeData}
                  onChange={handleSelectMode}
                  className="form-control optionSize"
                  placeholder="Select Region"
                >
                  <option value=""> Mode</option>
                  <option value="1">Air</option>
                  <option value="2">Train</option>
                  <option value="3">Road</option>
                </select>
                <span
                  className="arrow"
                  style={{
                    position: "relative",
                    marginLeft: "-32px",
                    marginTop: "14px",
                    color: "#BFBFBF",
                  }}
                >
                  &#9660;
                </span>
              </div>
              <div className="col fixArrow">
                <select
                  id="region"
                  name="region"
                  value={paymentModeData}
                  onChange={handleSelectPaymentMode}
                  className="form-control optionSize"
                  placeholder="Select Region"
                >
                  <option>Payment Mode</option>
                  <option value="Razorpay">Razorpay</option>
                  <option value="Bank">Bank</option>
                  <option value="Cash">Cash</option>
                </select>
                <span
                  className="arrow"
                  style={{
                    position: "relative",
                    marginLeft: "-32px",
                    marginTop: "14px",
                    color: "#BFBFBF",
                  }}
                >
                  &#9660;
                </span>
              </div>
              <div className="col fixArrow">
                <select
                  id="region"
                  name="region"
                  value={petCount}
                  onChange={handleSelectPetCount}
                  className="form-control optionSize"
                  placeholder="Select Region"
                >
                  <option>Pet Count</option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                </select>
                <span
                  className="arrow"
                  style={{
                    position: "relative",
                    marginLeft: "-32px",
                    marginTop: "14px",
                    color: "#BFBFBF",
                  }}
                >
                  &#9660;
                </span>
              </div>
              <div className="col fixArrow">
                <select
                  id="coordinatorName"
                  name="coordinatorName"
                  value={coordinatorName}
                  onChange={handleSelectCoordinator}
                  className="form-control optionSize"
                  onClick={getCoordinatorNames}
                >
                  <option value="">Coordinator</option>
                  {coordinatorFilterResponse.map((item) => (
                    <option key={item}>{item.Name}</option>
                  ))}
                </select>
                <span
                  className="arrow"
                  style={{
                    position: "relative",
                    marginLeft: "-32px",
                    marginTop: "14px",
                    color: "#BFBFBF",
                  }}
                >
                  &#9660;
                </span>
              </div>
            </div>
            <div className="row">
              <div className="col fixArrow">
                <input
                  id="inputDataValue"
                  name="inputDataValue"
                  value={inputDataValue}
                  onChange={handleSearchParamChange}
                  className="form-control optionSize"
                  placeholder="Enter Lead ID"
                />
              </div>
              <div className="col fixArrow">
                <select
                  id="fileSubmit"
                  name="fileSubmit"
                  value={fileSubmit}
                  onChange={handleSelectFileSubmit}
                  className="form-control optionSize"
                >
                  <option>File Submit In Accounts</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
                <span
                  className="arrow"
                  style={{
                    position: "relative",
                    marginLeft: "-32px",
                    marginTop: "14px",
                    color: "#BFBFBF",
                  }}
                >
                  &#9660;
                </span>
              </div>
              <div className="col fixArrow"></div>
              <div className="col fixArrow"></div>
            </div>
            <hr></hr>
            <div className="row">
              <div className="ApplyClearButton">
                <button
                  type="submit"
                  className="btn btn-danger"
                  onClick={resetForm}
                  style={{
                    marginTop: "12px",
                    border: "none",
                    color: "red",
                    backgroundColor: "white",
                    height: "47px",
                    width: "8rem",
                    fontWeight: "bold",
                  }}
                >
                  Clear Filter
                </button>
                <button
                  type="submit"
                  className="btn btn-primary applyButtonFilter"
                  onClick={getLeadDataButton}
                  style={{
                    marginTop: "12px",
                    marginLeft: "13px",
                    paddingTop: "1px",
                    height: "47px",
                    width: "8rem",
                  }}
                >
                  Apply
                </button>
              </div>
            </div>
          </div>
        </form>
      )}
      <br></br>
      <div className="headingLeadReport">
        <p>Converted Lead Report</p>
      </div>

      <div
        className="container-fluid hide-scrollbar1"
        style={{ width: "100%", overflowX: "auto" }}
      >
        <div className="petBreedList1">
          <table className="table-fixed">
            <thead className="cell-thead">
              <tr className="petBreedListHeading1">
                <th className="tr-th-column">Sr. No</th>
                <th className="tr-th-column">Lead Id</th>
                <th className="tr-th-column">Last Modified On</th>
                <th className="tr-th-column">Estimate Id</th>
                <th className="tr-th-column">Lead Entry Date</th>
                <th className="tr-th-column">Booking Date</th>
                <th className="tr-th-column">Execution Date</th>
                <th className="tr-th-column">Execution TAT</th>
                <th className="tr-th-column">AQCS NOC DATE</th>
                <th className="tr-th-column">Status</th>
                <th className="tr-th-column">Lead Source</th>
                <th className="tr-th-column">Lead Owner</th>
                <th className="tr-th-column">Lead Owner Email</th>
                <th className="tr-th-column">Coordinator</th>
                <th className="tr-th-column">Field Ops</th>
                <th className="tr-th-column">Ops Email ID</th>
                <th className="tr-th-column">Ops Contact Number</th>
                <th className="tr-th-column">Customer Name</th>
                <th className="tr-th-column">Shipper Name</th>
                <th className="tr-th-column">Contact Number</th>
                <th className="tr-th-column">Email</th>
                <th className="tr-th-column">Pet Type</th>
                <th className="tr-th-column">Breed</th>
                <th className="tr-th-column">Age ( In Months)</th>
                <th className="tr-th-column">Pet Dimn.</th>
                <th className="tr-th-column">Cage Size</th>
                <th className="tr-th-column">Pet Name</th>
                <th className="tr-th-column">Pet DOB</th>
                <th className="tr-th-column">No. of Pets</th>
                <th className="tr-th-column">Pet Behaviour</th>
                <th className="tr-th-column">Titre Test Status</th>
                <th className="tr-th-column">Job Type</th>
                <th className="tr-th-column">Region</th>
                <th className="tr-th-column">Origin</th>
                <th className="tr-th-column">Destination</th>
                <th className="tr-th-column">Origin Airport</th>
                <th className="tr-th-column">Arrival Airport</th>
                <th className="tr-th-column">Service Type</th>
                <th className="tr-th-column">Overseas Vendor</th>
                <th className="tr-th-column">Pet Boarding Vendor</th>
                <th className="tr-th-column">Mode</th>
                <th className="tr-th-column">Qty</th>
                <th className="tr-th-column">Cage Required</th>
                <th className="tr-th-column">Cage Status</th>
                <th className="tr-th-column">Cage Trained</th>
                <th className="tr-th-column">Amount In {currency}</th>
                <th className="tr-th-column">Quotation</th>
                <th className="tr-th-column">Payment Percentage</th>
                <th className="tr-th-column">Token Payment</th>
                <th className="tr-th-column">Remaining Payment</th>
                <th className="tr-th-column">Pymt Status</th>
                <th className="tr-th-column">Payment Mode</th>
                <th className="tr-th-column">Booking Status</th>
                <th className="tr-th-column">Pick up time</th>
                <th className="tr-th-column">Flight Time</th>
                <th className="tr-th-column">ETA</th>
                <th className="tr-th-column">Shipment Reference No.</th>
                <th className="tr-th-column">Booking Form</th>
                <th className="tr-th-column">Declaration</th>
                <th className="tr-th-column">Vacc Record</th>
                <th className="tr-th-column">Fit to fly</th>
                <th className="tr-th-column">ID proof</th>
                <th className="tr-th-column">Pan Card</th>
                <th className="tr-th-column">Add Proof</th>
                <th className="tr-th-column">Customer Ticket</th>
                <th className="tr-th-column">Remarks</th>
                <th className="tr-th-column">Review Link</th>
                <th className="tr-th-column">File Submit in Accounts</th>
              </tr>
            </thead>
            {loading ? (
              <div style={{ position: "relative", left: "540px" }}>
                <Loader />
              </div>
            ) : (
              <tbody className="hide-scrollbar1">
                {convertedleadResponse?.length > 0 ? (
                  convertedleadResponse.map((item, index) => (
                    <tr key={index}>
                      <td className="td-cell">
                        {(currentPage - 1) * itemsPerPage + index + 1}
                      </td>
                      <td className="td-cell"><a onClick={() => nextPage1(item.Relocation_ID)} style={{ fontWeight: "bold", cursor: "pointer" }} > {item.Relocation_ID}</a>   </td>
                      <td className="td-cell">{item.modifiedDate}</td>
                      <td className="td-cell">{item.Estimate_Id}</td>

                      <td className="td-cell">{item.lead_entry_date}</td>
                      <td className="td-cell">{item.Booking_Date}</td>
                      <td className="td-cell">{item.Execution_Date}</td>

                      <td className="td-cell">{item.Execution_TAT}</td>
                      <td className="td-cell">{item.AQCS_NOC_DATE}</td>

                      <td className="td-cell">{item.order_status}</td>

                      <td className="td-cell">{item.leadSource}</td>
                      <td className="td-cell">{item.Lead_Owner}</td>
                      <td className="td-cell">{item.lead_owner_email}</td>
                      <td className="td-cell">{item.Coordinator}</td>
                      <td className="td-cell">{item.Field_Ops || "N/A"}</td>
                      <td className="td-cell">{item.ops_emailId}</td>
                      <td className="td-cell">{item.ops_contactNumber}</td>

                      <td className="td-cell">{item.Customer_Name}</td>
                      <td className="td-cell">{item.Shipper_Name}</td>

                      <td className="td-cell">{item.Contact_Number}</td>
                      <td className="td-cell">{item.Email}</td>
                      <td className="td-cell">{item.pet_type}</td>
                      <td className="td-cell">{item.Breed}</td>
                      <td className="td-cell">{item.Age_In_Months}</td>
                      <td className="td-cell">{`(${item.Dim_A},${item.Dim_B},${item.Dim_C},${item.Dim_D})`}</td>
                      <td className="td-cell">{item.Cage_Size} </td>
                      <td className="td-cell">{item.Pet_Name}</td>
                      <td className="td-cell">{item.Pet_DOB}</td>
                      <td className="td-cell">{item.Number_of_Pets}</td>
                      <td className="td-cell">{item.Pet_Behaviour}</td>
                      <td className="td-cell">{item.Titre_Test_Status}</td>
                      <td className="td-cell">{item.Job_Type}</td>

                      <td className="td-cell">{item.region_name}</td>
                      <td className="td-cell">{item.origin_city}</td>
                      <td className="td-cell">{item.destination_city}</td>
                      <td className="td-cell">{item.Origin_Airport}</td>
                      <td className="td-cell">{item.Arrival_Airport}</td>
                      <td className="td-cell">{item.Service_Type}</td>
                      <td className="td-cell">{item.Overseas_Vendor}</td>
                      <td className="td-cell">{item.Pet_Boarding_Vendor}</td>

                      <td className="td-cell">{item.Mode}</td>
                      <td className="td-cell">{item.Qty}</td>
                      <td className="td-cell">{item.Cage_Required}</td>
                      <td className="td-cell">{item.Cage_Status}</td>
                      <td className="td-cell">{item.Cage_Trained}</td>
                      <td className="td-cell">{item.Amount_In_AED}</td>
                      <td className="td-cell">{item.Quotation}</td>
                      <td className="td-cell">{`${item.Payment_Ter}%`}</td>

                      <td className="td-cell">{item.Token_Payment}</td>
                      <td className="td-cell">{item.Remaining_Payment}</td>
                      <td className="td-cell">{item.Remaining_Payment}</td>
                      <td className="td-cell">{item.Pymt_Status}</td>
                      <td className="td-cell">{item.Payment_Mode}</td>
                      <td className="td-cell">{item.Booking_Status}</td>
                      <td className="td-cell">{item.Pick_up_time}</td>
                      <td className="td-cell">{item.Flight_Time}</td>
                      <td className="td-cell">{item.ETA}</td>
                      <td className="td-cell">{item.Shipment_Reference_No}</td>
                      <td className="td-cell">{item.Booking_Form}</td>
                      <td className="td-cell">{item.Declaration}</td>
                      <td className="td-cell">{item.Vacc_Record}</td>
                      <td className="td-cell">{item.Fit_to_fly}</td>
                      <td className="td-cell">{item.ID_proof}</td>
                      <td className="td-cell">{item.Pan_Card}</td>
                      <td className="td-cell">{item.Add_Proof}</td>
                      <td className="td-cell">{item.Customer_Ticket}</td>
                      <td className="td-cell">{item.Review_Link}</td>
                      <td className="td-cell">
                        {item.File_Submit_in_Accounts}
                      </td>
                    </tr>
                  ))
                ) : (
                  <p>empty</p>
                )}
              </tbody>
            )}
          </table>
        </div>
      </div>
    </>
  );
};
export default ConvertedSalesOrder;
